import { LoadableAfterPaint } from '@confluence/loadable';

export const GlobalComponentsLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-GlobalComponents" */ './GlobalComponents.tsx'))
			.GlobalComponents,
});
